import React, { useEffect } from 'react';
const pixelId = '1475685237698537';
type PixelFunction = {
  (...args: unknown[]): void;
  queue: unknown[][];
  loaded: boolean;
  version: string;
  push: PixelFunction;
  callMethod?: PixelFunction;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
    requestIdleCallback?: (callback: () => void, options?: {
      timeout: number;
    }) => number;
  }
}
function setupPixel() {
  if (typeof window === 'undefined' || window.fbq) return;
  const fbq = ((...args: unknown[]) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  }) as PixelFunction;
  fbq.queue = [];
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  window.fbq = fbq;
  window._fbq = fbq;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  fbq('init', pixelId);
  fbq('track', 'PageView');
}
export function MetaPixel() {
  useEffect(() => {
    // Defer tracking until the browser is idle so it never competes with the
    // first paint of the landing page.
    const start = () => {
      try {
        setupPixel();
      } catch {
        // Tracking must never prevent the landing page from rendering.
      }
    };
    if (window.requestIdleCallback) {
      window.requestIdleCallback(start, {
        timeout: 3000
      });
      return;
    }
    const timer = window.setTimeout(start, 2000);
    return () => window.clearTimeout(timer);
  }, []);
  return <noscript data-id="element-83" data-mp="2145vbiykifh0">
      <img alt="" height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`} data-id="element-84" data-mp="214ysbs7q5qly" />
    </noscript>;
}